/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { BuilderSmsRoutingModule } from './builder-sms-routing.module';
import { SmsListComponent } from './components/sms-list/sms-list.component';
import { SmsListBusinessService } from './resources';
import { CommunicationRestService } from '@gh/builder-shared-data';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSmsRoutingModule,
  ],
  declarations: [
    SmsListComponent,
  ],
  providers: [
    SmsListBusinessService,
    CommunicationRestService,
  ],
})
export class BuilderSmsModule {
}
